import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/admin/settings',
}).lazy(() => import('./settings.lazy').then((d) => d.Route))
